import hotelFundedOfferFallbackImage from "@/assets/images/hotel-funded-offer-fallback.webp";

/** Offer image, falling back to a bundled image when there's no safe (`https://`) remote one. */
export const getOfferImageSrc = (imageUrl?: string): string => {
  const hasSafeImage = imageUrl?.startsWith("https://") ?? false;
  return hasSafeImage && imageUrl ? imageUrl : hotelFundedOfferFallbackImage;
};
